import { FlexItemWithBox, QRCodeMask, QRCodeWrapper } from './styled';
import Flexbox, { FlexItem } from '@rezdy/components/Flexbox';
import React, { PureComponent } from 'react';
import Button from '@rezdy/components/Button';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'qrcode.react';
import TextStyle from '@rezdy/components/TextStyle';
import auth from '../../services/auth';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IQRCodeState {
    radioOpt?: string;
    isLoading: boolean;
    secretCode: string;
    showQrCode: boolean;
    copied: boolean;
    qrCodeUrl: string;
}

class GenerateQRCode extends PureComponent<WithTranslation, IQRCodeState> {
    state = {
        copied: false,
        isLoading: true,
        qrCodeUrl: '',
        secretCode: '',
        showQrCode: false,
    };

    async componentDidMount() {
        // errors are catch before
        const res = await auth.associateSoftwareToken();
        const { data } = res;
        this.setState({
            isLoading: false,
            qrCodeUrl: data.qrCodeUrl,
            secretCode: data.secretCode,
        });
    }

    onCopySecretCode = () => {
        const { copied } = this.state;

        if (!copied) {
            this.setState(
                {
                    copied: true,
                },
                () => {
                    setTimeout(() => {
                        this.setState({ copied: false });
                    }, 500);
                }
            );
        }
    };

    showQrCode = () => {
        this.setState({
            showQrCode: true,
        });
    };

    renderQRCode = () => {
        const { showQrCode, qrCodeUrl } = this.state;
        const { i18n } = this.props;

        return (
            <QRCodeWrapper>
                {showQrCode ? (
                    <QRCode value={qrCodeUrl} />
                ) : (
                    <QRCodeMask action="secondary" onClick={this.showQrCode} reversed>
                        {i18n.t('qrcode')}
                    </QRCodeMask>
                )}
            </QRCodeWrapper>
        );
    };

    renderSecretCode = () => {
        const { secretCode, copied } = this.state;
        const { i18n } = this.props;
        return (
            <>
                <CopyToClipboard text={secretCode}>
                    <Button onClick={this.onCopySecretCode} disabled={copied} action="secondary" type="button">
                        {copied ? i18n.t('qrCodeCopied') : i18n.t('qrCopySecretCode')}
                    </Button>
                </CopyToClipboard>
            </>
        );
    };

    render() {
        const { isLoading } = this.state;
        const { i18n } = this.props;

        if (isLoading) {
            return <TextStyle as="p">{i18n.t('messages.loading')}</TextStyle>;
        }

        return (
            <Flexbox>
                <FlexItem>{this.renderQRCode()}</FlexItem>
                <FlexItemWithBox>{this.renderSecretCode()}</FlexItemWithBox>
            </Flexbox>
        );
    }
}

export default withTranslation()(GenerateQRCode);
